export const ParamPropertyNameExclusions: string[] = ['searchString', 'sortParams', 'pageParams', 'prefilterKey', 'prefilter'];
